import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { OFFER_ANCHOR, PACK_IMAGE, PACK_IMAGE_ALT, PRODUCT_NAME } from '../data/content';
export function Hero() {
  return <header className="bg-navy" data-id="element-86" data-mp="ei1vfm5pk2xy">
      <div className="mx-auto max-w-3xl px-4 pb-4 pt-3 text-center sm:pt-6" data-id="element-87" data-mp="9k0f38zo2hq6">
        <p className="inline-block rounded bg-alert px-2 py-0.5 font-condensed text-xs font-bold text-white sm:text-sm" data-id="element-88" data-mp="4lyvmmybwge6">
          ⚙️ Método de enseñanza paso a paso
        </p>
        <h1 className="mt-1.5 font-display text-[1.5rem] font-extrabold leading-[1.12] text-white sm:text-5xl" data-id="element-89" data-mp="1274nzp1vrg78">
          El sistema completo para preparar y enseñar{' '}
          <span className="text-volt" data-id="element-90" data-mp="s9q6dm480ldc">Electromecánica de forma práctica y organizada</span>
        </h1>
        <p className="mx-auto mt-1.5 max-w-2xl text-[0.82rem] leading-snug text-white/80 sm:text-base" data-id="element-91" data-mp="nbonb16som1v">
          Accede a contenidos, actividades, evaluaciones, diagramas, planificaciones y proyectos para enseñar motores,
          contactores, automatismos, mantenimiento y diagnóstico — sin perder horas buscando material, preparando
          ejercicios y armando cada clase desde cero.
        </p>

        <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto mt-2 block max-w-xl transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.99]" data-id="element-92" data-mp="3o6u7fbahgtdg">
          <img src={PACK_IMAGE} alt={PACK_IMAGE_ALT} className="block w-full" data-id="element-93" data-mp="30ib0az366mmy" />
        </a>

        <p className="mt-2 rounded-md border-2 border-dashed border-volt bg-tech px-3 py-1.5 font-condensed text-[0.78rem] font-bold leading-tight text-white sm:text-base" data-id="element-94" data-mp="358rdqj6zq89b">
          ⚙️ {PRODUCT_NAME} · <span className="font-bebas text-base font-normal tracking-wide text-volt sm:text-xl" data-id="element-95" data-mp="2viy1dfz0xp40">6 Tomos + 5 Bonos</span>
        </p>

        <CtaBlock onDark note="Acceso Digital Inmediato • Garantía de 7 Días" data-id="element-96" data-mp="2hix2u768etrp" />
      </div>
    </header>;
}